import "./TimeRangePicker.html";
import "./TimeRangePicker.scss";

import "./RangeDirective";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import TimeRangePickerComponentController from "./TimeRangePickerComponentController";

export default class TimerRangePickerComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            colorTheme: "<", // purple, blue, green - default
            dayType: "<",
            isDisabled: "<",
            ranges: "=",
            staticRanges: "<",
        };
        this.controller = TimeRangePickerComponentController;
        this.templateUrl = "/App/Components/Forms/TimeRangePickerV2/TimeRangePicker.html";
    }
}

module("mmManagePortal").component("irTimeRangePickerV2", new TimerRangePickerComponent());
